import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Switch from '@material-ui/core/Switch';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {
    state = {
        active: this.props.active,
        rol: this.props.rol,
        local: this.props.local,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClose = (active, rol, local) => (event) => {
        this.props.handleClose(active, rol, local);
    };

    render() {
        const { active, local, rol } = this.state;
        const { intl, info } = this.props;
        const nodes = info.security.locals.reduce((arr, c) => {
            arr.push(c);
            return arr;
        }, []);

        const roles = info.security.roles.sort((a, b) => (a.name < b.name ? -1 : 1));
        console.log(roles.map((r) => r.id));
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="popup_all_users" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'active'}
                                checked={active}
                                onChange={this.handleChecked}
                                value="active"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'rol' })}
                            </InputLabel>
                            <Select
                                native
                                value={rol}
                                onChange={this.handleChange}
                                inputProps={{ name: 'rol', id: 'rol-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {roles &&
                                    roles.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                disabled={true}
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes
                                    .sort((a, b) => a.name > b.name ? 1 : -1)
                                    .map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(active, rol, local)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Filter = connect(
    mapStateToProps,
    null,
)(Filter);

Filter = injectIntl(Filter);

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometres/FilterMenu.js